import { render, staticRenderFns } from "./ModalSuccessful.vue?vue&type=template&id=74a142ca&"
import script from "./ModalSuccessful.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports